import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../magic_forms_2/store/hooks";
import {
  getAsesoresByCode,
  getBrandConfigByCode,
  resetCurrentAsesor,
  selectAsesores,
  selectBrandConfig,
  selectLoadingAsesores,
  selectLoadingBrandConfig,
} from "./asesorSlice";
import useQuery from "../utils/UseQuery";
import { ClipLoader } from "react-spinners";
import { AsesorPreviewCard } from "./components/AsesorPreviewCard";

export const AsesorDirectory = () => {
  const brandConfig = useAppSelector(selectBrandConfig);
  const loadingBrandConfig = useAppSelector(selectLoadingBrandConfig);
  const loadingAsesores = useAppSelector(selectLoadingAsesores);
  const asesoresList = useAppSelector(selectAsesores);

  const dispatch = useAppDispatch();

  const query = useQuery();
  const code = query.get("asesorCode") ?? "error";

  useEffect(() => {
    dispatch(resetCurrentAsesor());
    if (loadingAsesores === "idle" && code !== "error") {
      dispatch(getAsesoresByCode(code));
    }

    if (loadingBrandConfig === "idle" && code !== "error") {
      dispatch(getBrandConfigByCode(code));
    }
    return () => {};
  }, [code, dispatch, loadingBrandConfig, loadingAsesores]);

  const content = () => {
    if (loadingBrandConfig === "pending" || loadingAsesores === "pending") {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
          }}
        >
          <ClipLoader color={brandConfig.primaryTextColor} size={120} />;
          <h5
            style={{
              color: brandConfig.primaryTextColor,
              marginTop: "20px",
              fontSize: "20px",
            }}
          >
            Obteniendo información
          </h5>
        </div>
      );
    } else if (loadingAsesores === "resolved") {
      return (
        <div
          style={{
            fontFamily: "Open Sans",
            color: brandConfig.primaryTextColor,
            width: "100%",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            boxSizing: "border-box",
            padding: "1% 3%",
          }}
        >
          <img
            alt="Logo de la empresa"
            src={brandConfig.logoUrl!!}
            style={{
              maxWidth: "200px",
              maxHeight: "320px",
              width: "auto",
              height: "auto",
              margin: "10px 0 10px 0",
            }}
          />
          <p
            style={{
              fontSize: "15px",
              fontWeight: 500,
              margin: "20px 0 30px 0",
              textAlign: "start",
            }}
          >
            Te damos la bienvenida al portal de asesores, a continuación puedes
            seleccionar entre la siguiente lista de asesores y realizar procesos
            totalmente digitales.
          </p>
          {asesoresList.map((asesor) => {
            let asesorCargo = asesor.asesorData.cargo;
            if (!asesorCargo) {
              asesorCargo = asesor.asesorData.fieldsToShow?.find(
                (field) => field.id === "cargo"
              )?.value;
            }
            return (
              <AsesorPreviewCard
                key={asesor.id}
                asesorId={asesor.id}
                brandConfig={brandConfig}
                wholeName={asesor.name}
                cargo={asesorCargo}
              />
            );
          })}
        </div>
      );
    } else if (
      (loadingAsesores === "idle" && code === "error") ||
      loadingAsesores === "rejected"
    ) {
      return (
        <div
          style={{
            background: `linear-gradient(180deg, ${brandConfig.backgroundColor1}, ${brandConfig.backgroundColor2})`,
          }}
        ></div>
      );
    } else {
      return (
        <div
          style={{
            background: `linear-gradient(180deg, ${brandConfig.backgroundColor1}, ${brandConfig.backgroundColor2})`,
          }}
        ></div>
      );
    }
  };

  return (
    <div
      style={{
        width: "100vw",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        overflow: "auto",
        alignItems: "center",
        background: `linear-gradient(180deg, ${brandConfig.backgroundColor1} , ${brandConfig.backgroundColor2})`,
      }}
    >
      {content()}
    </div>
  );
};
